import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { Link } from "gatsby"

export default function VotingRecord() {
  const videos = [
    {
      text:
        "Please watch this 1 minute video sharing the reason CA Cities for Local Control was formed",
      youtubeVideoId: "_SDclEZyIaU",
    },
    {
      text:
        "Listen to the City of Covina discuss their support for CA Cities for Local Control",
      youtubeVideoId: "RUYJFmxRJBc",
    },
    {
      text:
        "Listen to the City of Bellflower discuss their support for CA Cities for Local Control",
      youtubeVideoId: "2ft0Z8yYyZ0",
    },
    {
      text:
        "Listen to the City of Anderson discuss their support for CA Cities for Local Control",
      youtubeVideoId: "BoF7bRmuTrk",
    },
  ]

  return (
    <Layout>
      <SEO title="2021 Voting Record" />
      <h1 className="text-center">Videos</h1>

      {videos.map(({ text, youtubeVideoId }) => {
        return (
          <div key={youtubeVideoId}>
            <a
              href={`https://www.youtube.com/watch?v=${youtubeVideoId}&feature=youtu.be`}
              target="_blank"
              rel="noreferrer"
              className="block mt-3 lg:hidden"
            >
              {text}
            </a>
            <div className="flex-col hidden lg:flex-row lg:flex">
              <p className="w-full p-0 text-2xl leading-relaxed lg:w-1/3 lg:pr-5">
                {text}
              </p>
              <iframe
                width="560"
                height="315"
                className="mt-5"
                src={`https://www.youtube.com/embed/${youtubeVideoId}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                title={text}
                allowFullScreen
              ></iframe>
            </div>
          </div>
        )
      })}

      <p className="mt-5 lg:mt-12">
        For more videos, please visit&nbsp;
        <a
          href="https://www.youtube.com/channel/UC6sx0NOQOTez_uwFK6dClgQ/featured"
          target="_blank"
          rel="noreferrer"
        >
          our YouTube channel.
        </a>
      </p>
    </Layout>
  )
}
